import React, { useState, useEffect, useRef } from 'react';
import Button from '../../components/ui/Button';
import { useNavigate } from 'react-router-dom';
const FeaturesSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [titleVisible, setTitleVisible] = useState(false);
  const [paraVisible, setParaVisible] = useState(false);
  const [hoveredCardId, setHoveredCardId] = useState(null);
  const sectionRef = useRef(null);
  const navigate = useNavigate();
  const handleShopNow = () => {
    navigate('/shop');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const cards = [
    {
      id: 1,
      title: 'CRESSON HONEY',
      description:
        'A robust and aromatic honey, capturing the wild essence of the Tunisian thyme fields.',
      image: '/images/CRESSON-HONEY-0.webp',
      hoverImage: '/images/CRESSON-HONEY.webp',
    },
    {
      id: 2,
      title: 'ORANGE HONEY',
      description: 'Infused with the essence of citrus blossoms, a refreshing and zesty flavor.',
      image: '/images/ORANGE-HONEY-0.webp',
      hoverImage: '/images/ORANGE-HONEY.webp',
    },
    {
      id: 3,
      title: 'WILD TRILOGY',
      description: 'Rich and caramel-like, harvested from date palm groves.',
      image: '/images/WILD-TRILOGY-0.webp',
      hoverImage: '/images/WILD-TRILOGY.webp',
    },
    {
      id: 4,
      title: 'Coming Soon',
      description: 'New varieties are being crafted with the same passion and dedication.',
      image: '/images/Comming-soon-jar.webp',
      hoverImage: '/images/Comming-soon-jar.webp',
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setIsVisible(true);
        });
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => sectionRef.current && observer.unobserve(sectionRef.current);
  }, []);

  useEffect(() => {
    if (isVisible) {
      setTitleVisible(true);
      setTimeout(() => setParaVisible(true), 300);
    }
  }, [isVisible]);

  return (
    <section
      ref={sectionRef}
      className={`bg-white section-spacing transition-all duration-1000 ease-in-out ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div className="container mx-auto px-4 md:px-8">
        <div className="mb-0">
          <h2
            className={`text-2xl md:text-4xl font-extralight text-[#000000] mb-6 text-center mt-10 transition-all duration-1000 ${
              titleVisible
                ? 'opacity-100 translate-y-0 animate-slideUp'
                : 'opacity-0 translate-y-10'
            }`}
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Explore Our Full Collection
          </h2>
          <p
            className={`md:text-xl text-[#666] max-w-4xl mx-auto px-8 text-center transition-all duration-1000 ${
              paraVisible ? 'opacity-100 translate-y-0 animate-slideUp' : 'opacity-0 translate-y-10'
            }`}
          >
            Discover the full range of Elixir's rare and exquisite honey varieties. Each one a
            unique expression of the Mediterranean terroir.
          </p>

          {/* Cards */}
          {/* Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-16">
            {cards.map((card) => (
              <div
                key={card.id}
                className="bg-white rounded-xl shadow-lg overflow-hidden transition-transform duration-300 hover:-translate-y-2 group"
                onMouseEnter={() => setHoveredCardId(card.id)}
                onMouseLeave={() => setHoveredCardId(null)}
              >
                <div className="relative w-full h-64 overflow-hidden">
                  <img
                    src={hoveredCardId === card.id ? card.hoverImage : card.image}
                    alt={card.title}
                    className="object-cover w-full h-full transition-opacity duration-500 ease-in-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-10 group-hover:bg-opacity-0 transition-all" />
                </div>
                <div className="p-5">
                  <h3 className="text-lg font-semibold text-[#1a1a1a] mb-2">{card.title}</h3>
                  <p className="text-sm text-[#555]">{card.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Button BELOW the grid and centered */}
          <div className="mt-12 flex justify-center">
            <Button
              variant="gold"
              size="large"
              onClick={handleShopNow}
              className="font-semibold rounded-3xl py-3 px-5"
            >
              Shop Now
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
